import CreateScenarioDialog from 'components/Dialog/ScenarioDialog';
import TabsBarsDescriptors from 'components/TabsBars/TabsBarsDescriptors';
import { actions as scenariosActions } from 'ducks/scenarios';
import ERCAmbiente from 'pages/ScenarioExposure/Flow/ScenariosManagement/ERCAmbiente';
import ExpandableScenarioConfig from 'pages/ScenarioExposure/Flow/ScenariosManagement/ExpansionBar';
import PCProduto from 'pages/ScenarioExposure/Flow/ScenariosManagement/PCProduto';
import PROCTrabalhadores from 'pages/ScenarioExposure/Flow/ScenariosManagement/PROCTrabalhadores';
import SUSectores from 'pages/ScenarioExposure/Flow/ScenariosManagement/SUSectores';
import BackgroundQuestion from 'pages/ScenarioExposure/sharedComponents/BackgroundQuestion';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {
  filterByFieldSelector, mixtureSubstancesBySubstance, rawMaterialIdsByFlow, shipmentsByRawMaterial
} from 'selectors/generic';
import { SCENARIO_EF } from 'utils/constants/coreConstants';
import { ERC_TAB, PC_TAB, PROC_TAB, SU_TAB } from 'utils/constants/descriptorTypes';
import { lcsInternalExposure } from 'utils/constants/lcsTypes';
import { TABLE_HEIGHT } from 'utils/ui/constants';

const TABLE_HEIGHT_QUESTION = TABLE_HEIGHT(false, 100);

const Component = props => {
  const {
    flowsData, lcssFactory, lcssById, mixtureSubstancesBySubstance, substanceId,
    rawMaterialIdsOfFlow, rawMaterialsById, scenarioDescriptorsData, scenariosData, scenariosById,
    shipmentsByRawMaterial,

    shipmentInitializer, scenarioInitializer
  } = props;
  const {
    createScenario, closeScenarioManagement, fetchScenarios, setSubstanceId,

    setShipmentInitializer, setScenarioInitializer
  } = props;

  const [createScenarioOpen, setCreateScenarioOpen] = useState(false);
  const handleCreateScenarioClose = () => setCreateScenarioOpen(false);
  const handleCreateScenarioOpen = () => setCreateScenarioOpen(true);

  /**  ******* Shipment initialization  ***********  */
  // Fetches Shipments from direct substance and from mixtures where substance might be in
  const shipmentInitialization = substance => {
      let shipment = {};
      const shipmentsOfSubstance = shipmentsByRawMaterial[substance.id] || [];
      const mixturesOfSubstance = mixtureSubstancesBySubstance[substance.id] || [];
      if (shipmentsOfSubstance.length > 0) {
        shipment = {
          ...shipmentsOfSubstance[0],
          shipment_substance_id: substance.id,
          shipment_id_mp: substance.id,
          raw_material_name: substance.name,
          raw_material_code: substance.code
        };
      } else if (mixturesOfSubstance.length > 0) {
        const mixIds = mixturesOfSubstance.map(mix => mix.mixture_id);
        let shipmentsFromMix = [];
        mixIds.forEach(id => {
          (shipmentsByRawMaterial[id] || []).forEach(shipt =>
            shipmentsFromMix.push({
              ...shipt,
              shipment_mixture_id: id,
              shipment_id_mp: id,
              raw_material_name: rawMaterialsById[id].name,
              raw_material_code: rawMaterialsById[id].code
            })
          );
        });
        if (shipmentsFromMix.length > 0) {
          shipment = shipmentsFromMix[0];
        }
      }
      return shipment;
    };
  /**  ******* Shipment initializarion END  ***********  */

  const scenarioInitialization = () => {
    const scenarios = scenariosData.filter(s =>
      s.raw_material_supplier_id === shipment.id && parseInt(s.lcs_id) === lcs.id
    );
    return scenarios.length > 0 ? scenarios[0].id : null;
  };

  const substance = rawMaterialsById[substanceId];
  // Same as the product side: no descriptor of that type, no first element.
  const defaultLcsId = lcssFactory[0]?.id || null;
  const [lcsId, setLcsId] = useState(scenarioInitializer?.lcs_id || defaultLcsId);
  const lcs = lcssById[lcsId];
  const [shipment, setShipment] = useState(shipmentInitializer ? shipmentInitializer : null);
  const [scenarioId, setScenarioId] = useState(scenarioInitializer ? scenarioInitializer.id : null);
  const scenario = scenariosById[scenarioId];
  const [loading, setLoading] = useState(null);
  const [descriptorTab, setDescriptorTab] = useState(PC_TAB);


  useEffect(() => {
      if (shipmentInitializer) {
        setShipmentInitializer(null);
      } else {
        setShipment(shipmentInitialization(substance));
      }
    }, [substanceId]
  );

  useEffect(() => {
      if (scenarioInitializer) {
        setScenarioInitializer(null);
      } else {
        setScenarioId(scenarioInitialization());
      }
    },
    [substanceId, shipment, lcsId, scenariosData]
  );



  /**  ******* Exposure Scenarios/Scenario information  ***********  */
  const scenarios = scenariosData.filter(s =>
    s.raw_material_supplier_id === shipment.id && parseInt(s.lcs_id) === lcs.id
  );
  /**  ******* Exposure Scenario information END ***********  */

  /**  ******* Flow Scenario information  ***********  */
  const flowsShipment = flowsData.filter(
      flow => (rawMaterialIdsOfFlow[flow.id] || []).includes(shipment.shipment_id_mp));
  const flowsShipmetIds = flowsShipment.map(flowShip => flowShip.id);

  const flowScenarios = scenariosData.filter(scenario =>
    scenario.flow_id && scenario.lcs_id == lcs.id && flowsShipmetIds.includes(scenario.flow_id)
  );

  const flowScenariosIds = flowScenarios.map(fS => fS.id);
  const flowScenarioDescriptors = scenarioDescriptorsData.filter(scenarioDescriptor =>
    flowScenariosIds.includes(scenarioDescriptor.scenario_id)
  );
  /**  ******* Flow Scenario information END  ***********  */

  const newScenario = (code, description, notes) => {
    setLoading(true);
    createScenario({
      substance_id: substanceId,
      raw_material_supplier_id: shipment.id,
      code: code,
      designation: description,
      lcs_id: lcs.id,
      type: SCENARIO_EF
    })
      .then(() => {
        fetchScenarios();
      })
      .finally(() => {
        setCreateScenarioOpen(false);
        setLoading(false);
      });
  };

  const CreateScenarioQuestion = () => {
    return (
      <BackgroundQuestion
        bodyHeight={TABLE_HEIGHT_QUESTION}
        label='Criar cenário'
        onClick={handleCreateScenarioOpen}
        submitting={loading}
      >
        <div>
          <p>
            O cenário seleccionado para a combinação de Substância <b>{rawMaterialsById[substanceId].name}</b>,
            LCS <b>{lcs.description}</b> e Fornecimento <b>{shipment.trade_name}</b> não existe, pretende criá-lo?
          </p>
        </div>
      </BackgroundQuestion>
    );
  };

  const WorkingArea = descriptorTab => {
    switch (descriptorTab) {
      case PC_TAB:
        return (
          <PCProduto
            flowScenarioDescriptors={flowScenarioDescriptors}
            lcs={lcs}
            scenario={scenario}
            substanceId={substanceId}
          />
        );

      case SU_TAB:
        return (
          <SUSectores
            flowScenarioDescriptors={flowScenarioDescriptors}
            lcs={lcs}
            scenario={scenario}
            substanceId={substanceId}
          />
        );

      case ERC_TAB:
        return (
          <ERCAmbiente
            flowScenarioDescriptors={flowScenarioDescriptors}
            lcs={lcs}
            scenario={scenario}
            substanceId={substanceId}
          />
        );

      case PROC_TAB:
        return (
          <PROCTrabalhadores
            flowScenarioDescriptors={flowScenarioDescriptors}
            lcs={lcs}
            scenario={scenario}
            substanceId={substanceId}
            // Extra data needed to know the flows in use and take out steps/MPS
            flowScenarios={flowScenarios}
          />
        );
    }
  };

  return (
    <React.Fragment>
      <ExpandableScenarioConfig
        currentOptionSubstance={substance}
        onSelectionSubstance={setSubstanceId}
        currentOptionLcs={lcs}
        onSelectionLcs={setLcsId}
        currentOptionShipment={shipment}
        onSelectionShipment={setShipment}
        scenarios={scenarios}
        currentOptionScenario={scenario}
        onSelectionScenario={setScenarioId}
        handleCreateScenarioOpen={handleCreateScenarioOpen}
        closeScenarioManagement={closeScenarioManagement}
      />
      <TabsBarsDescriptors value={descriptorTab} setValue={setDescriptorTab}/>
      {
        scenario ?
          WorkingArea(descriptorTab) :
          CreateScenarioQuestion()
      }
      {
        createScenarioOpen &&
        <CreateScenarioDialog
          open={createScenarioOpen}
          code={`${rawMaterialsById[substanceId].name}_${shipment.code}_${lcs.description}`}
          description={lcs.description}
          handleClose={handleCreateScenarioClose}
          handleSubmit={newScenario}
        />
      }
    </React.Fragment>
  );
};

const makeMapStateToProps = () => {
  const lcssFactory = filterByFieldSelector('descriptors', 'id', lcsInternalExposure);
  const mapStateToProps = (state, props) => ({
    rawMaterialIdsOfFlow: rawMaterialIdsByFlow(state),
    lcssFactory: lcssFactory(state),
    lcssById: state.descriptors.models,
    mixtureSubstancesBySubstance: mixtureSubstancesBySubstance(state),
    rawMaterialsById: state.rawMaterials.models,
    scenariosData: state.scenarios.data,
    scenariosById: state.scenarios.models,
    scenarioDescriptorsData: state.scenarioDescriptors.data,
    shipmentsByRawMaterial: shipmentsByRawMaterial(state),
    shipmentsById: state.rawMaterialSuppliers.models,
    flowsData: state.flows.data
  });
  return mapStateToProps;
};

const mapDispatchToProps = dispatch => ({
  createScenario: data => dispatch(scenariosActions.createPromise(data)),
  fetchScenarios: () => dispatch(scenariosActions.fetchAll())
});

export default connect(makeMapStateToProps, mapDispatchToProps)(Component);
